import React from 'react';
import { render } from 'react-dom';
import CompareListComponent from '../react/CompareList';

export default class CompareListRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, baseApi } = this.context.dataset;
    if (!model || !baseApi) throw Error('Missing a required dataset');

    const jsonModel = JSON.parse(model);
    const { maximumCompareAmount, ...labels } = jsonModel;

    render(
      <CompareListComponent
        labels={labels}
        maximumCompareAmount={maximumCompareAmount}
        baseApi={baseApi}
      />,
      this.context
    );
  }
}
